/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import styled from 'styled-components';

import constants from '../../constants';

const device = {
  desktop: `(min-width:${constants.displaySizes.desktop})`,
  largeDesktop: `(min-width:${constants.displaySizes.largeDesktop})`,
  smallDesktop: `(min-width:${constants.displaySizes.smallDesktop})`,
  mobile: `(max-width:${constants.displaySizes.mobile})`,
  tablet: `(min-width:${constants.displaySizes.tablet})`,
};

export const ContentContainer = styled.div`
  padding: var(--spacing-relative-xl) var(--page-margin) 0;
`;

export const MediaDisclaimerContainer = styled.div`
  ${process.env.IS_LEGACY
    ? // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (props) => `background-color: ${props?.theme?.sys?.color?.canvas?.default}`
    : ''};
  position: relative;
  bottom: 0px;
  height: fit-content;

  a:focus {
    outline: 5px auto Highlight !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }

  span sup a {
    font-size: 10px !important;
    font-feature-settings: normal !important;
    font-weight: 500;
  }
  @media ${device.tablet} {
    display: flex;
    flex-direction: row;
    span {
      margin-right: 16px;
    }
  }
`;

export const WLTPContainer = styled.div`
  ${process.env.IS_LEGACY
    ? // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (props) => `background-color: ${props?.theme?.sys?.color?.canvas?.default}`
    : ''};
  position: relative;
  bottom: 0px;
  height: fit-content;
  a:focus {
    outline: 5px auto Highlight !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }
  span sup a {
    font-size: 10px !important;
    font-weight: 500;
  }
  @media ${device.tablet} {
    flex-direction: row;
    span {
      margin-right: 16px;
    }
    span sup a {
      font-size: 10px !important;
      font-weight: 500;
    }
  }

  @media screen and (max-width: ${constants.displaySizes.smallDesktop}) {
    span {
      :not(:last-child)::after {
        content: '; ';
      }
    }
  }
`;
